import { arComponentBlockEntry } from "../blocks/ar-component";
import { heroBlockEntry } from "../blocks/hero";
import { heroCenteredBlockEntry } from "../blocks/hero-centered";
import { featureGridBlockEntry } from "../blocks/feature-grid";
import { ctaBlockEntry } from "../blocks/cta";
import { contactFormBlockEntry } from "../blocks/contact-form";
import { logoWallBlockEntry } from "../blocks/logo-wall";
import { personGridBlockEntry } from "../blocks/person-grid";
import { statCardBlockEntry } from "../blocks/stat-card";
import { richTextBlockEntry } from "../blocks/rich-text";
import { accordionBlockEntry } from "../blocks/accordion";
import { careersListBlockEntry } from "../blocks/careers-list";
import { heroMedia2ColumnBlockEntry } from "../blocks/hero-media-2-column";
import { carouselBlockEntry } from "../blocks/carousel";
import { resourceCardsBlockEntry } from "../blocks/resource-cards";
import { heroMediaCenteredBlockEntry } from "../blocks/hero-media-centered";
import { textHeroBlockEntry } from "../blocks/text-hero";
import { calloutBlockEntry } from "../blocks/callout";
import { collectionListBlockEntry } from "../blocks/collection-list";
import { newsListBlockEntry } from "../blocks/news-list";
import { articleHeaderBlockEntry } from "../blocks/article-header";
import { chaptersBlockEntry } from "../blocks/chapters";
import { promoBlockEntry } from "../blocks/promo";
import { promo2ColumnBlockEntry } from "../blocks/promo-2-column";
import { statementBlockEntry } from "../blocks/statement";
import { timelineBlockEntry } from "../blocks/timeline";
import { featuredPressBlockEntry } from "../blocks/featured-press";
import { mediaBlockEntry } from "../blocks/media";
import { promoImageBlockEntry } from "../blocks/promo-image";
import { videoBlockEntry } from "../blocks/video";
import { highlightsBlockEntry } from "../blocks/highlights";
import { playgroundBannerBlockEntry } from "../blocks/playground-banner";
import { playgroundCardBlockEntry } from "../blocks/playground-card";
import { playgroundVideoBlockEntry } from "../blocks/playground-video";
import { playgroundReelBlockEntry } from "../blocks/playground-reel";
import { playgroundMediaBlockEntry } from "../blocks/playground-media";
/**
 * componentId → block entry. The single map the renderer consults. Adding a
 * block = build it under ../blocks and register it here (its catalog entry in
 * @diality/contracts is what the CMS palette + manifest read).
 */
export const blockRegistry = {
    Hero: heroBlockEntry,
    HeroCentered: heroCenteredBlockEntry,
    FeatureGrid: featureGridBlockEntry,
    Cta: ctaBlockEntry,
    // Legacy alias: earlier seed/manifest data used "Newsletter" for the
    // email-capture/CTA panel, now unified under the Cta block.
    Newsletter: ctaBlockEntry,
    ContactForm: contactFormBlockEntry,
    LogoWall: logoWallBlockEntry,
    PersonGrid: personGridBlockEntry,
    StatCard: statCardBlockEntry,
    RichText: richTextBlockEntry,
    Accordion: accordionBlockEntry,
    CareersList: careersListBlockEntry,
    HeroMedia2Column: heroMedia2ColumnBlockEntry,
    ResourceCards: resourceCardsBlockEntry,
    Carousel: carouselBlockEntry,
    HeroMediaCentered: heroMediaCenteredBlockEntry,
    TextHero: textHeroBlockEntry,
    Callout: calloutBlockEntry,
    CollectionList: collectionListBlockEntry,
    NewsList: newsListBlockEntry,
    ArticleHeader: articleHeaderBlockEntry,
    Chapters: chaptersBlockEntry,
    Promo: promoBlockEntry,
    Promo2Column: promo2ColumnBlockEntry,
    Statement: statementBlockEntry,
    Timeline: timelineBlockEntry,
    FeaturedPress: featuredPressBlockEntry,
    Media: mediaBlockEntry,
    PromoImage: promoImageBlockEntry,
    ARComponent: arComponentBlockEntry,
    Video: videoBlockEntry,
    Highlights: highlightsBlockEntry,
    // Test-only playground blocks, registered UNCONDITIONALLY so the same
    // cms/web builds that ship to prod render them in acceptance runs;
    // production gating happens at the manifest filter
    // (api/scripts/generate-manifest.ts), never here.
    PlaygroundBanner: playgroundBannerBlockEntry,
    PlaygroundCard: playgroundCardBlockEntry,
    PlaygroundVideo: playgroundVideoBlockEntry,
    PlaygroundReel: playgroundReelBlockEntry,
    // Same renderer as Media, by design — see blocks/playground-media.tsx.
    PlaygroundMedia: playgroundMediaBlockEntry,
};
export function getBlockEntry(componentId) {
    return blockRegistry[componentId];
}
//# sourceMappingURL=registry.js.map